// ES6 Polyfill
import 'core-js/stable';
import 'regenerator-runtime/runtime';

// Functional Polyfill
import '../../../../../src/js/polyfills/customEvent';
import 'intersection-observer';

// LazyLoading
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';

import sidebarNavigation from '../../../../../src/js/modules/sidebarNavigation';
import header from '../../../../../src/js/modules/header';
import elementStateToggle from '../../../../../src/js/modules/elementStateToggle';
import intersection from '../../../../../src/js/modules/intersection';
import sliderTeaser from '../../../../../src/js/modules/sliderTeaser';
import share from '../../../../../src/js/modules/share';
import printImage from '../../../../../src/js/modules/printImage';
import raceTracking from '../../../../../src/js/modules/race/raceTracking';

window.addEventListener('load', () => {
    sidebarNavigation.init();
    header.init();
    sliderTeaser.init();

    /**
     * Author Description
     */
    elementStateToggle.init({
        triggerElementSelector: '.js-author-detail-toggle',
        toggleActiveElement: true,
    });

    intersection.init();
    share.init();
    printImage.init();
    raceTracking.init();
}, false);
